import { Component } from 'react';
import { Dialog, DialogContent } from '../components/Dialog';

interface Props {
  isShow: boolean;
  onHide: () => void;
  videoUrl: string;
  videoTitle: string;
}

export class VideoPlayer extends Component<Props> {
  constructor(props: Props) {
    super(props);

    this.handleHide = this.handleHide.bind(this);
  }

  handleHide() {
    this.props.onHide();
  }

  render() {
    return (
      <Dialog
        open={this.props.isShow}
        onOpenChange={(isOpen) => {
          if (!isOpen) {
            this.handleHide();
          }
        }}
      >
        <DialogContent
          className='w-[min(95vw,960px)] rounded-[0.6rem] border-0 bg-white p-0 text-[1.6rem] shadow-[0_14px_34px_rgba(0,0,0,0.2)]'
          overlayClassName='bg-black/55'
        >
          <div className='relative border-b border-[#dee2e6] px-[1.6rem] pb-[1.2rem] pt-[1.4rem]'>
            <button
              type='button'
              onClick={this.handleHide}
              aria-label='Close'
              className='absolute right-[1rem] top-[0.7rem] border-0 bg-transparent p-0 text-[2.4rem] leading-none text-[#242424]'
            >
              x
            </button>
            <h3 className='m-0 text-[2rem] leading-[1.2] text-[#242424]'>{this.props.videoTitle}</h3>
          </div>
          <div className='p-[1.6rem]'>
            <iframe
              title='Video'
              src={`${this.props.videoUrl}?autoplay=1&showinfo=0`}
              allow='autoplay'
              className='h-[56.25vw] max-h-[70vh] min-h-[260px] w-full rounded-[0.4rem]'
              frameBorder={0}
              allowFullScreen
            />
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}
